import React from "react";
import { borrowerPortalUrl } from "../../../lib/constants/SiteVariables";
import { formatCurrency } from "../../../lib/utils/formatters";
import "./postApproval.css";

export const ApprovalBadge = () => (
  <span className="post-approval-badge">Approved</span>
);
export const ApprovalHeading = ({ creditLimit }) => (
  <h2>
    {Number.isFinite(creditLimit)
      ? `You’re approved for ${formatCurrency(creditLimit)}!`
      : "You’re approved!"}
  </h2>
);
export const ApprovalCopy = () => (
  <>
    <p>
      You’re good to go! We told you it would be easy. Simply choose{" "}
      <span className="text-primary-blue">Credit Key</span> at checkout.
    </p>
    <p>
      Access your account at{" "}
      <a href={borrowerPortalUrl} target="_blank" rel="noreferrer">
        www.creditkey.com
      </a>
    </p>
  </>
);
export const ApprovalSupport = () => (
  <aside className="post-approval-support">
    <strong>Any questions or issues?</strong>
    <p>
      Contact Credit Key Support at{" "}
      <a href="mailto:support@creditkey.com">support@creditkey.com</a> or{" "}
      <a href="tel:+18443343636">+1 (844) 334-3636</a>
    </p>
  </aside>
);
export const LinkedBank = ({ account }) =>
  account ? (
    <div className="post-approval-bank ph-mask-text">
      <div>
        <p className="font-medium">
          {account.institution || "Linked bank account"}
        </p>
        <p className="text-xs">
          {account.name || "Account"}
          {account.mask ? ` •••• ${account.mask}` : null}
        </p>
      </div>
    </div>
  ) : null;
export const ApprovalCard = ({ children, className = "", ...props }) => (
  <section {...props} className={`post-approval-card ${className}`}>
    {children}
  </section>
);
